export default __webpack_public_path__ + "static/media/q1_step2_6.bce3b5a2.png";